export const appName = "Devebsy" 
